import { APP_SERVICE, AppService } from "@cervval.js/common/services";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { Lang } from "@cervval.js/common/src/i18n/languages";
import { DefaultErrorMessageService } from "@cervval.js/common/src/services/errorMessage.impl/default.errorMessage.service";
import { ERROR_MESSAGE_SERVICE } from "@cervval.js/common/src/services/errorMessage.service";
import { getLineProxyErrorMessages } from "../line/errors/customErrors";

/** All the app custom errors */
const customErrorMessages = (lang?: Lang): Record<number, string> => {
    return {
        ...getLineProxyErrorMessages(lang)
    };
};

/** Register App custom errors */
export function registerCustomErrors(): void {
    const appService = injector.get<AppService>(APP_SERVICE);
    const errorMessageService = injector.get<DefaultErrorMessageService<string>>(ERROR_MESSAGE_SERVICE);
    const messages: Record<string, Record<number, string>> = {
        [appService.lang]: customErrorMessages(appService.lang)
    };
    errorMessageService.registerErrorMessages(messages);

}